"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var FileSize = /** @class */ (function (_super) {
    __extends(FileSize, _super);
    function FileSize() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileSize.prototype.render = function () {
        if (this.props.documentSizeBytes) {
            var size = parseInt(this.props.documentSizeBytes, 10);
            var sizeKb = 1000.0;
            var sizeMb = sizeKb * sizeKb;
            var sizeGb = sizeMb * sizeKb;
            var sizeTb = sizeGb * sizeKb;
            if (size < sizeMb) {
                return Math.round((size / sizeKb) * 10) / 10 + ' KB';
            }
            else if (size < sizeGb) {
                return Math.round((size / sizeMb) * 10) / 10 + ' MB';
            }
            else if (size < sizeTb) {
                return Math.round((size / sizeGb) * 10) / 10 + ' GB';
            }
        }
        return '';
    };
    FileSize.propTypes = {
        documentSizeBytes: prop_types_1.default.any,
    };
    return FileSize;
}(react_1.default.Component));
exports.default = FileSize;
//# sourceMappingURL=FileSize.js.map